<div class="datalist">
	<div class="item-form">
		<i class="bi bi-pin-map icon black bg-gray"></i>
		<input
			autocomplete="off"
			class="form-control bg-gray"
			type="text"
			[name]="inputName"
			[placeholder]="placeholder"
			[(ngModel)]="textFilterInput"
			(input)="onTextFilterChange()"
			(blur)="onTextFilterFocusOut()"
			[ngClass]="{
				'--valid': optionHasBeenSelected
			}" />
	</div>
	<cmv-error-message *ngIf="isFilteredListEmpty">
		No se encontrarón resultados para: <strong>{{ textFilterInput }}</strong>
	</cmv-error-message>
	<ul
		class="datalist__source"
		[ngClass]="{ 'datalist__source--hide': filteredList.length === 0 }">
		<li
			*ngFor="let option of filteredList; let i = index; trackBy: trackByItem"
			(click)="onSelected(option)">
			{{ option.description }}
		</li>
	</ul>
</div>
